const enterpriseInquiryLinkPattern = /data-enterprise-inquiry\s*=\s*['"]1['"]/i;

export const defaultDisclaimer =
  "This version of DICOM Vision<sup>&reg;</sup> is intended for research, educational, and image review use and is not certified as a medical device for primary diagnosis.<br />For an MDR-compliant version of DICOM Vision<sup>&reg;</sup>, <a data-enterprise-inquiry='1'>Contact us</a>";

export const isEnterpriseInquiryEnabled = store => {
  const catalog = store?.state?.billing?.catalog;
  if (catalog && Object.prototype.hasOwnProperty.call(catalog, "billing_enabled")) {
    return Boolean(catalog.billing_enabled);
  }
  return Boolean(String(process.env.GOOGLE_CLIENT_ID || "").trim());
};

export const renderDisclaimer = (
  disclaimerText,
  { includeEnterpriseInquiry = true } = {}
) => {
  const text = typeof disclaimerText === "string" ? disclaimerText : "";
  if (!text || includeEnterpriseInquiry) {
    return text;
  }

  return text
    .split(/<br\s*\/?>/gi)
    .map(line => line.trim())
    .filter(line => !enterpriseInquiryLinkPattern.test(line))
    .join("<br />");
};
